export type BILLING_LOAD_ACCOUNTS = 'BILLING/LOAD_ACCOUNTS';
export const BILLING_LOAD_ACCOUNTS: BILLING_LOAD_ACCOUNTS = 'BILLING/LOAD_ACCOUNTS';

export type BILLING_LOAD_ENQUIRIES = 'BILLING/LOAD_ENQUIRIES';
export const BILLING_LOAD_ENQUIRIES: BILLING_LOAD_ENQUIRIES = 'BILLING/LOAD_ENQUIRIES';

export type BILLING_LOAD_ENQUIRY_DETAILS = 'BILLING/LOAD_ENQUIRY_DETAILS';
export const BILLING_LOAD_ENQUIRY_DETAILS: BILLING_LOAD_ENQUIRY_DETAILS = 'BILLING/LOAD_ENQUIRY_DETAILS';

export type BILLING_LOAD_CIDN = 'BILLING/LOAD_CIDN';
export const BILLING_LOAD_CIDN: BILLING_LOAD_CIDN = 'BILLING/LOAD_CIDN';

export type BILLING_LOAD_INVOICE_DETAIL = 'BILLING/LOAD_INVOICE_DETAIL';
export const BILLING_LOAD_INVOICE_DETAIL: BILLING_LOAD_INVOICE_DETAIL = 'BILLING/LOAD_INVOICE_DETAIL';

export type BILLING_LOAD_INVOICE_DETAIL_NEW = 'BILLING/LOAD_INVOICE_DETAIL_NEW';
export const BILLING_LOAD_INVOICE_DETAIL_NEW: BILLING_LOAD_INVOICE_DETAIL_NEW = 'BILLING/LOAD_INVOICE_DETAIL_NEW';

export type BILLING_LOAD_INVOICE_DETAIL_UPDATED_STRUCTURE = 'BILLING/LOAD_INVOICE_DETAIL_UPDATED_STRUCTURE';
export const BILLING_LOAD_INVOICE_DETAIL_UPDATED_STRUCTURE: BILLING_LOAD_INVOICE_DETAIL_UPDATED_STRUCTURE =
    'BILLING/LOAD_INVOICE_DETAIL_UPDATED_STRUCTURE';

export type BILLING_LOAD_PAYMENT_DETAILS = 'BILLING/LOAD_PAYMENT_DETAILS';
export const BILLING_LOAD_PAYMENT_DETAILS: BILLING_LOAD_PAYMENT_DETAILS = 'BILLING/LOAD_PAYMENT_DETAILS';

export type BILLING_LOAD_ACCOUNT_NUMBERS = 'BILLING/LOAD_ACCOUNT_NUMBERS';
export const BILLING_LOAD_ACCOUNT_NUMBERS: BILLING_LOAD_ACCOUNT_NUMBERS = 'BILLING/LOAD_ACCOUNT_NUMBERS';

export type BILLING_LOAD_LATEST_INVOICE = 'BILLING/LOAD_LATEST_INVOICE';
export const BILLING_LOAD_LATEST_INVOICE: BILLING_LOAD_LATEST_INVOICE = 'BILLING/LOAD_LATEST_INVOICE';

export type BILLING_LOAD_TRANSACTION_LIST = 'BILLING/LOAD_TRANSACTION_LIST';
export const BILLING_LOAD_TRANSACTION_LIST: BILLING_LOAD_TRANSACTION_LIST = 'BILLING/LOAD_TRANSACTION_LIST';

export type BILLING_LOAD_ADJUSTMENT_LIST = 'BILLING/LOAD_ADJUSTMENT_LIST';
export const BILLING_LOAD_ADJUSTMENT_LIST: BILLING_LOAD_ADJUSTMENT_LIST = 'BILLING/LOAD_ADJUSTMENT_LIST';

export type BILLING_LOAD_PAYMENT_TRANSACTION_DETAIL = 'BILLING/LOAD_PAYMENT_TRANSACTION_DETAIL';
export const BILLING_LOAD_PAYMENT_TRANSACTION_DETAIL: BILLING_LOAD_PAYMENT_TRANSACTION_DETAIL =
    'BILLING/LOAD_PAYMENT_TRANSACTION_DETAIL';

export type BILLING_LOAD_REPAYMENT_DETAIL = 'BILLING/LOAD_REPAYMENT_DETAIL';
export const BILLING_LOAD_REPAYMENT_DETAIL: BILLING_LOAD_REPAYMENT_DETAIL = 'BILLING/LOAD_REPAYMENT_DETAIL';

export type BILLING_LOAD_ADJUSTMENT_DETAIL = 'BILLING/LOAD_ADJUSTMENT_DETAIL';
export const BILLING_LOAD_ADJUSTMENT_DETAIL: BILLING_LOAD_ADJUSTMENT_DETAIL = 'BILLING/LOAD_ADJUSTMENT_DETAIL';

export type BILLING_LOAD_USAGE_DETAIL = 'BILLING/LOAD_USAGE_DETAIL';
export const BILLING_LOAD_USAGE_DETAIL: BILLING_LOAD_USAGE_DETAIL = 'BILLING/LOAD_USAGE_DETAIL';

export type BILLING_LOAD_ORDER_DETAIL = 'BILLING/LOAD_ORDER_DETAIL';
export const BILLING_LOAD_ORDER_DETAIL: BILLING_LOAD_ORDER_DETAIL = 'BILLING/LOAD_ORDER_DETAIL';

export type BILLING_LOAD_REFUND_ADJUSTMENT_DETAIL = 'BILLING/LOAD_REFUND_ADJUSTMENT_DETAIL';
export const BILLING_LOAD_REFUND_ADJUSTMENT_DETAIL:
BILLING_LOAD_REFUND_ADJUSTMENT_DETAIL = 'BILLING/LOAD_REFUND_ADJUSTMENT_DETAIL';

export type BILLING_CHANGE_STICKY_FOOTER_DEFAULT_STATE = 'BILLING/CHANGE_STICKY_FOOTER_DEFAULT_STATE';
export const BILLING_CHANGE_STICKY_FOOTER_DEFAULT_STATE:
BILLING_CHANGE_STICKY_FOOTER_DEFAULT_STATE = 'BILLING/CHANGE_STICKY_FOOTER_DEFAULT_STATE';

export type BILLING_CHANGE_STICKY_FOOTER_DEFAULT_STATE_UPDATED_STRUCTURE =
    'BILLING/CHANGE_STICKY_FOOTER_DEFAULT_STATE_UPDATED_STRUCTURE';
export const BILLING_CHANGE_STICKY_FOOTER_DEFAULT_STATE_UPDATED_STRUCTURE:
BILLING_CHANGE_STICKY_FOOTER_DEFAULT_STATE_UPDATED_STRUCTURE =
    'BILLING/CHANGE_STICKY_FOOTER_DEFAULT_STATE_UPDATED_STRUCTURE';

export type BILLING_STICKY_FOOTER_INIT_STATE = 'BILLING/STICKY_FOOTER_INIT_STATE';
export const BILLING_STICKY_FOOTER_INIT_STATE:
BILLING_STICKY_FOOTER_INIT_STATE = 'BILLING/STICKY_FOOTER_INIT_STATE';

export type BILLING_STICKY_FOOTER_INIT_STATE_UPDATED_STRUCTURE = 'BILLING/STICKY_FOOTER_INIT_STATE_UPDATED_STRUCTURE';
export const BILLING_STICKY_FOOTER_INIT_STATE_UPDATED_STRUCTURE:
BILLING_STICKY_FOOTER_INIT_STATE_UPDATED_STRUCTURE = 'BILLING/STICKY_FOOTER_INIT_STATE_UPDATED_STRUCTURE';

export type BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS = 'BILLING/INVOICE_ENQUIRIES_UPDATE_ITEMS';
export const BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS:
BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS = 'BILLING/INVOICE_ENQUIRIES_UPDATE_ITEMS';

export type BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS_UPDATED_STRUCTURE =
    'BILLING/INVOICE_ENQUIRIES_UPDATE_ITEMS_UPDATED_STRUCTURE';
export const BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS_UPDATED_STRUCTURE:
BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS_UPDATED_STRUCTURE =
    'BILLING/INVOICE_ENQUIRIES_UPDATE_ITEMS_UPDATED_STRUCTURE';

export type BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS = 'BILLING/DRILLDOWN_ENQUIRIES_UPDATE_ITEMS';
export const BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS:
BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS = 'BILLING/DRILLDOWN_ENQUIRIES_UPDATE_ITEMS';

export type BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_UPDATED_STRUCTURE
    = 'BILLING/DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_UPDATED_STRUCTURE';
export const BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_UPDATED_STRUCTURE:
BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_UPDATED_STRUCTURE =
    'BILLING/DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_UPDATED_STRUCTURE';

export type BILLING_LOAD_REDEMPTION_DETAIL = 'BILLING/LOAD_REDEMPTION_DETAIL';
export const BILLING_LOAD_REDEMPTION_DETAIL: BILLING_LOAD_REDEMPTION_DETAIL = 'BILLING/LOAD_REDEMPTION_DETAIL';

export type BILLING_LOAD_DISCOUNT_DETAIL = 'BILLING/LOAD_DISCOUNT_DETAIL';
export const BILLING_LOAD_DISCOUNT_DETAIL: BILLING_LOAD_DISCOUNT_DETAIL = 'BILLING/LOAD_DISCOUNT_DETAIL';

export type BILLING_LOAD_RECURRING_DETAIL = 'BILLING/LOAD_RECURRING_DETAIL';
export const BILLING_LOAD_RECURRING_DETAIL: BILLING_LOAD_RECURRING_DETAIL = 'BILLING/LOAD_RECURRING_DETAIL';

export type BILLING_SUBMIT_ENQUIRY = 'BILLING/SUBMIT_ENQUIRY';
export const BILLING_SUBMIT_ENQUIRY:
BILLING_SUBMIT_ENQUIRY = 'BILLING/SUBMIT_ENQUIRY';

export type BILLING_LOAD_MDM_USAGE_DETAIL = 'BILLING/LOAD_MDM_USAGE_DETAIL';
export const BILLING_LOAD_MDM_USAGE_DETAIL:
BILLING_LOAD_MDM_USAGE_DETAIL = 'BILLING/LOAD_MDM_USAGE_DETAIL';

export type BILLING_LOAD_FEATURE_PACK_DETAIL = 'BILLING/LOAD_FEATURE_PACK_DETAIL';
export const BILLING_LOAD_FEATURE_PACK_DETAIL: BILLING_LOAD_FEATURE_PACK_DETAIL = 'BILLING/LOAD_FEATURE_PACK_DETAIL';

export type BILLING_STICKY_HEADER_INIT_STATE = 'BILLING/STICKY_HEADER_INIT_STATE';
export const BILLING_STICKY_HEADER_INIT_STATE:
BILLING_STICKY_HEADER_INIT_STATE = 'BILLING/STICKY_HEADER_INIT_STATE';

export type BILLING_CHANGE_STICKY_HEADER_DEFAULT_STATE = 'BILLING/CHANGE_STICKY_HEADER_DEFAULT_STATE';
export const BILLING_CHANGE_STICKY_HEADER_DEFAULT_STATE:
BILLING_CHANGE_STICKY_HEADER_DEFAULT_STATE = 'BILLING/CHANGE_STICKY_HEADER_DEFAULT_STATE';

export type BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_HEADER = 'BILLING/DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_HEADER';
export const BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_HEADER:
BILLING_DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_HEADER = 'BILLING/DRILLDOWN_ENQUIRIES_UPDATE_ITEMS_HEADER';

export type BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS_HEADER = 'BILLING/INVOICE_ENQUIRIES_UPDATE_ITEMS_HEADER';
export const BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS_HEADER:
BILLING_INVOICE_ENQUIRIES_UPDATE_ITEMS_HEADER = 'BILLING/INVOICE_ENQUIRIES_UPDATE_ITEMS_HEADER';

export type BILLING_LOAD_BILLING_ACCOUNT_DETAIL = 'BILLING/LOAD_BILLING_ACCOUNT_DETAIL';
export const BILLING_LOAD_BILLING_ACCOUNT_DETAIL:
BILLING_LOAD_BILLING_ACCOUNT_DETAIL = 'BILLING/LOAD_BILLING_ACCOUNT_DETAIL';

export type BILLING_LOAD_VOICE_PRE_BILL = 'BILLING/LOAD_VOICE_PRE_BILL';
export const BILLING_LOAD_VOICE_PRE_BILL:
BILLING_LOAD_VOICE_PRE_BILL = 'BILLING/LOAD_VOICE_PRE_BILL';

export type BILLING_CANCEL_MODAL_STATE = 'BILLING/CANCEL_MODAL_STATE';
export const BILLING_CANCEL_MODAL_STATE:
BILLING_CANCEL_MODAL_STATE = 'BILLING/CANCEL_MODAL_STATE';

export type BILLING_LARGE_FILE_DOWNLOAD_STATUS =
    'BILLING/LARGE_FILE_DOWNLOAD_STATUS';
export const BILLING_LARGE_FILE_DOWNLOAD_STATUS:
BILLING_LARGE_FILE_DOWNLOAD_STATUS =
    'BILLING/LARGE_FILE_DOWNLOAD_STATUS';

export type BILLING_ZIP_FILE_DOWNLOAD_STATUS =
    'BILLING/ZIP_FILE_DOWNLOAD_STATUS';
export const BILLING_ZIP_FILE_DOWNLOAD_STATUS:
BILLING_ZIP_FILE_DOWNLOAD_STATUS =
    'BILLING/ZIP_FILE_DOWNLOAD_STATUS';
export type BILLING_LOAD_FEATURE_PACK_DETAIL_LATEST =
    'BILLING/LOAD_FEATURE_PACK_DETAIL_LATEST';
export const BILLING_LOAD_FEATURE_PACK_DETAIL_LATEST: BILLING_LOAD_FEATURE_PACK_DETAIL_LATEST =
    'BILLING/LOAD_FEATURE_PACK_DETAIL_LATEST';
export type BILLING_LOAD_MY_BILL_INVOICE_DETAIL = 'BILLING/LOAD_MY_Bill_INVOICE_DETAIL';
export const BILLING_LOAD_MY_BILL_INVOICE_DETAIL: BILLING_LOAD_MY_BILL_INVOICE_DETAIL = 'BILLING/LOAD_MY_Bill_INVOICE_DETAIL';

export type BILLING_LOAD_DOWNLOAD_INVOICE_FROM_S3 =
    'BILLING/LOAD_DOWNLOAD_INVOICE_FROM_S3';
export const BILLING_LOAD_DOWNLOAD_INVOICE_FROM_S3:
BILLING_LOAD_DOWNLOAD_INVOICE_FROM_S3 =
    'BILLING/LOAD_DOWNLOAD_INVOICE_FROM_S3';
export type BILLING_ALERT_DISPLAY_STATUS =
    'BILLING/ALERT_DISPLAY_STATUS';
export const BILLING_ALERT_DISPLAY_STATUS:
BILLING_ALERT_DISPLAY_STATUS =
    'BILLING/ALERT_DISPLAY_STATUS';
export type BILLING_BADGE_TOOLTIP_WRAPPER =
    'BILLING/BADGE_TOOLTIP_WRAPPER';
export const BILLING_BADGE_TOOLTIP_WRAPPER:
BILLING_BADGE_TOOLTIP_WRAPPER =
    'BILLING/BADGE_TOOLTIP_WRAPPER';
export type BILLING_INVOICE_BADGE_TOOLTIP_WRAPPER =
    'BILLING/INVOICE_BADGE_TOOLTIP_WRAPPER';
export const BILLING_INVOICE_BADGE_TOOLTIP_WRAPPER:
BILLING_INVOICE_BADGE_TOOLTIP_WRAPPER =
    'BILLING/INVOICE_BADGE_TOOLTIP_WRAPPER';
export type BILLING_ADD_COMMENT = 'BILLING/ADD_COMMENT';
export const BILLING_ADD_COMMENT: BILLING_ADD_COMMENT = 'BILLING/ADD_COMMENT';
export type BILLING_ENQUIRY_FILE_UPLOAD = 'BILLING/ENQUIRY_FILE_UPLOAD';
export const BILLING_ENQUIRY_FILE_UPLOAD: BILLING_ENQUIRY_FILE_UPLOAD = 'BILLING/ENQUIRY_FILE_UPLOAD';
export type BILLING_ENQUIRY_ACTIVITY_LOG = 'BILLING/ENQUIRY_ACTIVITY_LOG';
export const BILLING_ENQUIRY_ACTIVITY_LOG: BILLING_ENQUIRY_ACTIVITY_LOG = 'BILLING/ENQUIRY_ACTIVITY_LOG';
export type BILLING_LOAD_ATTACHMENT_LIST = 'BILLING/LOAD_ATTACHMENT_LIST';
export const BILLING_LOAD_ATTACHMENT_LIST: BILLING_LOAD_ATTACHMENT_LIST = 'BILLING/LOAD_ATTACHMENT_LIST';
export type BILLING_BRAINTREE_PAYMENT_TOKEN = 'BILLING/GET_PAYMENT_TOKEN';
export const BILLING_BRAINTREE_PAYMENT_TOKEN: BILLING_BRAINTREE_PAYMENT_TOKEN = 'BILLING/GET_PAYMENT_TOKEN';
export type BILLING_ADD_DEBITCARD_DETAIL = 'BILLING/ADD_DEBITCARD_DETAIL';
export const BILLING_ADD_DEBITCARD_DETAIL: BILLING_ADD_DEBITCARD_DETAIL = 'BILLING/ADD_DEBITCARD_DETAIL';
export type BILLING_LOAD_DD_AGREEMENT = 'BILLING/LOAD_DD_AGREEMENT';
export const BILLING_LOAD_DD_AGREEMENT: BILLING_LOAD_DD_AGREEMENT = 'BILLING/LOAD_DD_AGREEMENT';
export type BILLING_UPDATE_DEBITCARD_DETAIL = 'BILLING/UPDATE_DEBITCARD_DETAIL';
export const BILLING_UPDATE_DEBITCARD_DETAIL: BILLING_UPDATE_DEBITCARD_DETAIL = 'BILLING/UPDATE_DEBITCARD_DETAIL';
export type BILLING_REMOVE_DEBITCARD_DETAIL = 'BILLING/REMOVE_DEBITCARD_DETAIL';
export const BILLING_REMOVE_DEBITCARD_DETAIL: BILLING_REMOVE_DEBITCARD_DETAIL = 'BILLING/REMOVE_DEBITCARD_DETAIL';
export type BILLING_LOAD_QUERIED_CHARGES = 'BILLING/LOAD_QUERIED_CHARGES';
export const BILLING_LOAD_QUERIED_CHARGES: BILLING_LOAD_QUERIED_CHARGES = 'BILLING/LOAD_QUERIED_CHARGES';
export type BILLING_EXPORT_QUERIED_CHARGES = 'BILLING/EXPORT_QUERIED_CHARGES';
export const BILLING_EXPORT_QUERIED_CHARGES: BILLING_EXPORT_QUERIED_CHARGES = 'BILLING/EXPORT_QUERIED_CHARGES';
export type BILLING_ADD_CREDITCARD_DETAIL = 'BILLING/ADD_CREDITCARD_DETAIL';
export const BILLING_ADD_CREDITCARD_DETAIL: BILLING_ADD_CREDITCARD_DETAIL = 'BILLING/ADD_CREDITCARD_DETAIL';
export type BILLING_EXPORT_FILES = 'BILLING/EXPORT_FILES';
export const BILLING_EXPORT_FILES: BILLING_EXPORT_FILES = 'BILLING/EXPORT_FILES';
export type BILLING_SHOW_AEM_BANNER = 'BILLING/BILLING_SHOW_AEM_BANNER';
export const BILLING_SHOW_AEM_BANNER: BILLING_SHOW_AEM_BANNER = 'BILLING/BILLING_SHOW_AEM_BANNER';
export type BILLING_SHOW_AEM_BANNER_ERROR = 'BILLING/BILLING_SHOW_AEM_BANNER_ERROR';
export const BILLING_SHOW_AEM_BANNER_ERROR: BILLING_SHOW_AEM_BANNER_ERROR = 'BILLING/BILLING_SHOW_AEM_BANNER_ERROR';
export type BILLING_LOAD_PAYMENT_METHOD = 'BILLING/LOAD_PAYMENT_METHOD';
export const BILLING_LOAD_PAYMENT_METHOD: BILLING_LOAD_PAYMENT_METHOD = 'BILLING/LOAD_PAYMENT_METHOD';
export type BILLING_CLOSE_CREDIT_FORM = 'BILLING/BILLING_CLOSE_CREDIT_FORM';
export const BILLING_CLOSE_CREDIT_FORM: BILLING_CLOSE_CREDIT_FORM = 'BILLING/BILLING_CLOSE_CREDIT_FORM';
export type BILLING_EDIT_PAYMENT_DETAIL = 'BILLING/EDIT_PAYMET_DETAIL';
export const BILLING_EDIT_PAYMENT_DETAIL: BILLING_EDIT_PAYMENT_DETAIL = 'BILLING/EDIT_PAYMET_DETAIL';
export type BILLING_ADD_PAYMENT_METHODS = 'BILLING/ADD_PAYMENT_METHODS';
export const BILLING_ADD_PAYMENT_METHODS: BILLING_ADD_PAYMENT_METHODS = 'BILLING/ADD_PAYMENT_METHODS';
export type BILLING_DELETE_PAYMENT_METHODS = 'BILLING/DELETE_PAYMENT_METHODS';
export const BILLING_DELETE_PAYMENT_METHODS: BILLING_DELETE_PAYMENT_METHODS = 'BILLING/DELETE_PAYMENT_METHODS';
export type BILLING_DISABLED_DELETE_BTN = 'BILLING/BILLING_DISABLED_DELETE_BTN';
export const BILLING_DISABLED_DELETE_BTN: BILLING_DISABLED_DELETE_BTN = 'BILLING/BILLING_DISABLED_DELETE_BTN';
export type BILLING_VOICE_PREBILL_SERVICE_STATUS = 'BILLING/VOICE_PREBILL_SERVICE_STATUS';
export const BILLING_VOICE_PREBILL_SERVICE_STATUS: BILLING_VOICE_PREBILL_SERVICE_STATUS = 'BILLING/VOICE_PREBILL_SERVICE_STATUS';
export type BILLING_USAGE_HISTORY_SERVICE_STATUS = 'BILLING/USAGE_HISTORY_SERVICE_STATUS';
export const BILLING_USAGE_HISTORY_SERVICE_STATUS: BILLING_USAGE_HISTORY_SERVICE_STATUS = 'BILLING/USAGE_HISTORY_SERVICE_STATUS';
